import { getSavedLocale } from '@/i18n';
import { ARMADO_URL, isDevelopmentEnv } from '@/utils/CONST';
import axios from 'axios';
import { loggerRequestInterceptor, loggerResponseErrorInterceptor, loggerResponseInterceptor, responseErrorInterceptorAsync } from './axios.interceptor';

export default function () {
	const httpClient = axios.create({
		baseURL: `${ARMADO_URL}/app`,
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json',
			'Cache-Control': 'no-cache',
			'Accept-Language': getSavedLocale(), // Ajoute la langue actuelle
		},
		paramsSerializer: {
			indexes: null,
			dots: true,
		},
	});

	// Intercepteur pour toujours envoyer la langue actuelle
	httpClient.interceptors.request.use((config) => {
		config.headers['Accept-Language'] = getSavedLocale();
		return config;
	});

	if (isDevelopmentEnv) {
		httpClient.interceptors.request.use(loggerRequestInterceptor);
		httpClient.interceptors.response.use(loggerResponseInterceptor, loggerResponseErrorInterceptor);
	}

	httpClient.interceptors.response.use(undefined, responseErrorInterceptorAsync);

	return httpClient;
}
